<template>
  <div class="dataReport">
    <header>
      <h1 class="title">{{ customerName }}</h1>
    </header>
    <div class="spin_container" style="min-height: 100px; ">
      <a-spin class="spin" v-show="isDeviceLoading" />
      <ul class="device_wrapper" v-show="!isDeviceLoading">
        <li :class="{ ammeter: !isAmmeterOpen }" style="margin-right: 0;">
          <div class="header">
            <h3>{{ $t('station.DB') }}</h3>
            <span @click="changeAmmeterOpenSate">
              {{ isAmmeterOpenMessage }}
              <a-icon type="double-left" v-show="isAmmeterOpen" />
              <a-icon type="double-right" v-show="!isAmmeterOpen" />
            </span>
            <div class="border"></div>
          </div>
          <div class="body" v-show="isAmmeterOpen">
            <li
              v-for="e in elctricityMeterList"
              :key="e.id"
            >
              <label
                :for="e.code"
                :title="e.name"
              >
                <span class="deviceName">{{ e.name }}</span>
                <input
                  :id="e.code"
                  v-model="e.checked"
                  type="checkbox"
                  style="margin-right: 10px;"
                >
              </label>
            </li>
          </div>
        </li>
      </ul>
    </div>
    <div class="content spin_container" style="min-height: 600px;" v-show="isContentLoading">
      <a-spin class="spin" size="large" />
    </div>
    <div class="content" v-show="!isContentLoading">
      <div class="header">
        <ul class="models" style="margin-bottom: 20px;">
          <li @click="toggleContentType('dataReport')" :class="{ active: activeContentType === 'dataReport' }" style="margin-left: 0;">{{ $t('station.dataReport1') }}</li>
          <li @click="toggleContentType('comparison')" :class="{ active: activeContentType === 'comparison' }">{{ $t('dataReport.comparison') }}</li>
        </ul>
        <div class="dateController report" v-show="activeContentType === 'dataReport'">
          <div class="category_conatiner">
            <span
              v-for="c in categories"
              :key="c.key"
              :class="{ active: c.key === activeCategory }"
              @click="toggleCategory(c)"
            >
              {{ $t(c.text) }}
            </span>
          </div>
          <el-date-picker
            size="small"
            type="date"
            align="right"
            unlink-panels
            style="background-color: #2f3d4f"
            :key="lang"
            v-model="dayDate"
            v-show="activeCategory === 'day'"
          />
          <el-date-picker
            size="small"
            type="daterange"
            align="right"
            unlink-panels
            style="background-color: #2f3d4f"
            :key="lang + '1'"
            :picker-options="pickerOptions"
            v-model="monthDate"
            v-show="activeCategory === 'month'"
            @change="validateDateRange('monthDate', 31)"
          />
          <el-date-picker
            v-show="activeCategory === 'year'"
            v-model="yearDate"
            type="monthrange"
            style="background-color: #2f3d4f"
            unlink-panels
            :key="lang + '2'"
          />
          <a-button type="primary" @click="refreshData">{{ $t('buttons.search') }}</a-button>
          <a-button type="primary" :loading="isExporting" @click="handleExport">{{ $t('buttons.export') }}</a-button>
          <a-button type="primary" @click="isRemarkShow = true" style="position: absolute; right: 0px">{{ $t('dataReport.calculation') }}</a-button>
          <a-modal width="641px" v-model="isRemarkShow" :title="$t('dataReport.calculation')" @ok="isRemarkShow = false">
            <ul class="remarkUl">
              <li v-for="i in remarkList[lang]" :key="i.label">
                <i>{{ i.label }}</i>{{ i.content }}
              </li>
            </ul>
          </a-modal>
        </div>
        <div class="dateController" v-show="activeContentType === 'comparison'">
          <div class="category_conatiner">
            <span
              v-for="c in timeTypes_comparison"
              :key="c.key"
              :class="{ active: c.key === activeTimeType_comparison }"
              @click="toggleCategory_comparison(c)"
            >
              {{ $t(c.text) }}
            </span>
          </div>
          <div class="timeRange" v-show="activeTimeType_comparison === 'day'">
            <label>{{ $t('dataReport.timeRange') }}1: </label>
            <el-date-picker
              size="small"
              type="date"
              align="right"
              unlink-panels
              style="background-color: #2f3d4f"
              :key="lang + '3'"
              v-model="dayDateStart"
            />
            <label style="margin-left: 15px;">{{ $t('dataReport.timeRange') }}2: </label>
            <el-date-picker
              size="small"
              type="date"
              align="right"
              unlink-panels
              style="background-color: #2f3d4f"
              :key="lang + '4'"
              v-model="dayDateEnd"
            />
          </div>
          <div class="timeRange" v-show="activeTimeType_comparison === 'week'">
            <label>{{ $t('dataReport.timeRange') }}1: </label>
            <el-date-picker
              unlink-panels
              v-model="weekDateStart"
              type="week"
              :format="weekStartFormatter"
            />
            <label style="margin-left: 15px;">{{ $t('dataReport.timeRange') }}2: </label>
            <el-date-picker
              unlink-panels
              v-model="weekDateEnd"
              type="week"
              :format="weekEndFormatter"
            />
          </div>
          <div class="timeRange" v-show="activeTimeType_comparison === 'month'">
            <label>{{ $t('dataReport.timeRange') }}1: </label>
            <el-date-picker
              size="small"
              type="month"
              align="right"
              unlink-panels
              style="background-color: #2f3d4f"
              :key="lang + '5'"
              v-model="monthDateStart"
            />
            <label style="margin-left: 15px;">{{ $t('dataReport.timeRange') }}2: </label>
            <el-date-picker
              size="small"
              type="month"
              align="right"
              unlink-panels
              style="background-color: #2f3d4f"
              :key="lang + '6'"
              v-model="monthDateEnd"
            />
          </div>
          <div class="timeRange" v-show="activeTimeType_comparison === 'year'">
            <label>{{ $t('dataReport.timeRange') }}1: </label>
            <el-date-picker
              unlink-panels
              v-model="yearDateStart"
              type="year"
            />
            <label style="margin-left: 15px;">{{ $t('dataReport.timeRange') }}2: </label>
            <el-date-picker
              unlink-panels
              v-model="yearDateEnd"
              type="year"
            />
          </div>
          <a-button type="primary" @click="refreshData_comparison">{{ $t('dataReport.compare') }}</a-button>
        </div>
      </div>
      <table v-show="activeContentType === 'dataReport'">
        <thead>
          <tr>
            <th style="width: 360px;">{{ $t('dataReport.timeRange') }}</th>
            <th>{{ $t('station.electricity') }}(kW·h)</th>
            <th>{{ $t('dataReport.res') }}(kW·h)</th>
            <th>{{ $t('dataReport.ree') }}(kW·h)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="d in datas"
            :key="d.datetime"
          >
            <td style="width: 360px;">{{ d.datetime }}</td>
            <td>{{ d.powerConsumption }}</td>
            <td>{{ d.es }}</td>
            <td>{{ d.ee }}</td>
          </tr>
        </tbody>
      </table>
      <div class="charts">
        <ul class="type" v-show="activeContentType === 'dataReport'">
          <li @click="toggleChartType('line')" :class="{ active: activeChartType === 'line' }">{{ $t('line') }}</li>
          <li @click="toggleChartType('bar')" :class="{ active: activeChartType === 'bar' }">{{ $t('bar') }}</li>
        </ul>
        <ul class="charts_group">
          <li
            v-for="item in dataTypeList"
            :key="item.key"
          >
            <h3>{{ item.title[lang] }}</h3>
            <hr />
            <div style="position: relative;">
              <div class="minandmax" v-show="activeContentType === 'dataReport'">
                <p>{{ $t('min') }}{{item.min || 0}}</p>
                <p>{{ $t('max') }}{{item.max || 0}}</p>
              </div>
              <div class="chart" :id="item.dataIndex"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import moment from 'moment'
import {
  searchDeviceList,
  getDayReport,
  getMonthReport,
  getYearReport,
  exportNewReportByDay,
  exportNewReportByMonth,
  exportNewReportByYear
} from "@/api/device"
import {
  dayRemarkList,
  monthRemarkList,
  yearRemarkList
} from '@/views/EquipmentManager/EquipmentGroupPreview/remark'

export default {
  data() {
    return {
      en,
      zh,
      customerName: "",
      isDeviceLoading: true,
      isContentLoading: true,
      activeModelIndex: -1,
      dayRemarkList,
      monthRemarkList,
      yearRemarkList,
      elctricityMeterList: [],
      isAmmeterOpenMessage: "",
      isAmmeterOpen: true,
      categories: [
        {
          key: 'day',
          text: 'dataReport.day'
        },
        {
          key: 'month',
          text: 'dataReport.month'
        },
        {
          key: 'year',
          text: 'dataReport.year'
        }
      ],
      activeCategory: "day",
      dayDate: null,
      monthDate: null,
      yearDate: null,
      datas: [],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('station.tld'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: this.$t('station.tlw'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: this.$t('station.tlm'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit("pick", [start, end])
            }
          }
        ]
      },
      isRemarkShow: false,
      remarkList: [],
      activeChartType: "bar",
      dataTypeList: [],
      activeContentType: "dataReport",
      timeTypes_comparison: [
        {
          key: 'day',
          text: 'dataReport.day'
        },
        {
          key: 'week',
          text: 'dataReport.week'
        },
        {
          key: 'month',
          text: 'dataReport.month'
        },
        {
          key: 'year',
          text: 'dataReport.year'
        }
      ],
      activeTimeType_comparison: "day",
      dayDateStart: null,
      dayDateEnd: null,
      weekDateStart: null,
      weekDateEnd: null,
      monthDateStart: null,
      monthDateEnd: null,
      yearDateStart: null,
      yearDateEnd: null,
      isExporting: false,
      unit: ""
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    },
    weekStartFormatter() {
      return moment(this.weekDateStart).format("YYYY-MM-DD") + " ~ " + moment(this.weekDateStart).add(6, "days").format("YYYY-MM-DD") + " " + this.$t('dataReport.weekFormatter')
    },
    weekEndFormatter() {
      return moment(this.weekDateEnd).format("YYYY-MM-DD") + " ~ " + moment(this.weekDateEnd).add(6, "days").format("YYYY-MM-DD") + " " + this.$t('dataReport.weekFormatter')
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.dayDate = new Date()
    const date_month_start = new Date()
    date_month_start.setMonth(new Date().getMonth() - 1)
    this.monthDate = [date_month_start, new Date()]
    const date_year_start = new Date()
    date_year_start.setFullYear(new Date().getFullYear() - 1)
    let date = new Date()
    const start = new Date(date.getFullYear() - 1, date.getMonth(), 1)
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    this.yearDate = [start, end]
    this.remarkList = dayRemarkList
    this.dayDateStart = new Date(new Date().setDate(date.getDate() - 2))
    this.dayDateEnd = new Date(new Date().setDate(date.getDate() - 1))
    let s = date.getDay()
    this.weekDateEnd = new Date(new Date().setDate(date.getDate() - s - 6))
    this.weekDateStart = new Date(new Date().setDate(this.weekDateEnd.getDate() - 7))
    this.monthDateStart = new Date(date.getFullYear(), date.getMonth() - 2, 1)
    this.monthDateEnd = new Date(date.getFullYear(), date.getMonth() - 1, 1)
    this.yearDateStart = new Date(date.getFullYear() - 1, 0, 1)
    this.yearDateEnd = new Date(date.getFullYear(), 0, 1)
  },
  async mounted() {
    this.render()
  },
  methods: {
    translate() {
      locale.use(this[this.lang])
      this.isAmmeterOpenMessage = this.isAmmeterOpen === true ? this.$t('buttons.fold') : this.$t('buttons.expand')
      this.pickerOptions.shortcuts[0].text = this.$t('station.tld')
      this.pickerOptions.shortcuts[1].text = this.$t('station.tlw')
      this.pickerOptions.shortcuts[2].text = this.$t('station.tlm')
      if (this.charts) {
        if (this.activeContentType === "dataReport") {
          this.renderChart(this.activeChartType, this.activeCategory)
        }
        if (this.activeContentType === "comparison") {
          this.renderChart_comparison()
        }
      } 
    },
    async requestDeviceInfo(p) {
      try {
        let params = p || {
          query: [],
          filter: [
            {
              field: "id",
              value: this.$route.query.id
            }
          ],
          sort: []
        }
        const { data } = await searchDeviceList(1, 10000, params)
        if (data.total) {
          return data
        } else {
          return {
            records: []
          }
        }
      } catch(e) {
        console.log(e)
        return {
          records: []
        }
      }
    },
    async render() {
      try {
        let deviceInfo = {}
        const { records } = await this.requestDeviceInfo()
        if (records?.length) {
          deviceInfo = records[0]
        }
        this.customerName = deviceInfo.customer?.company || ""
        this.setDataTypeListAndColumns()
        this.elctricityMeterList = []

        let devices
        if (this.customerName) {
          devices = await this.requestDeviceInfo({
            query: [],
            filter: [
              {
                field: "customerId",
                value: deviceInfo.customer.id
              },
              {
                field: "type",
                value: "DB"
              },
              {
                field: "mode",
                value: "and"
              }
            ],
            sort: []
          })
        }
        if (devices?.records?.length) {
          devices = devices.records
        } else {
          devices = []
        }
        this.elctricityMeterList = devices.map(d => {
          if (d.id === +this.$route.query.id) {
            d.checked = true
          }
          return d
        })
        this.isDeviceLoading = false
        this.refreshData()
      } catch(e) {
        console.log(e)
        this.isDeviceLoading = false
        this.isContentLoading = false
      }
    },
    async getData() {
      const deviceCodes = []
      let device
      try {
        for (let i = 0; i < this.elctricityMeterList.length; i++) {
          device = this.elctricityMeterList[i]
          if (device.checked) {
            deviceCodes.push(device.code)
          }
        }
        switch(this.activeCategory) {
          case "day":
            if (!this.dayDate) {
              this.$message.error(this.$t("device.selectTime"))
              return []
            }
            const { data } = await getDayReport(moment(this.dayDate).format("YYYY-MM-DD"), deviceCodes + "")
            const start = moment(this.dayDate.setHours(0, 0, 0, 0)).format("YYYY-MM-DD HH:mm:ss")
            this.formatData(data, start)
            return data
          case "month":
            if (!this.monthDate) {
              this.isContentLoading = false
              this.$message.error(this.$t("placeholder.timeRange"))
              return []
            }
            if (!this.validateDateRange("monthDate", 31)) {
              this.isContentLoading = false
              return []
            }
            const monthDateStartFormatter = moment(this.monthDate[0]).format("YYYY-MM-DD")
            const { data: monthData } = await getMonthReport(monthDateStartFormatter, moment(this.monthDate[1]).format("YYYY-MM-DD"), deviceCodes + "")
            this.formatData(monthData)
            return monthData
          case "year":
            if (!this.yearDate) {
              this.isContentLoading = false
              this.$message.error(this.$t("placeholder.timeRange"))
              return []
            }
            const yearDateStartFormatter = moment(this.yearDate[0]).format("YYYY-MM-DD")
            const yearDateEndFormatter = moment(+new Date(this.yearDate[1].getFullYear(), this.yearDate[1].getMonth() + 1, 0)).format("YYYY-MM-DD")
            const { data: yearData } = await getYearReport(yearDateStartFormatter, yearDateEndFormatter, deviceCodes + "")
            this.formatData(yearData,  yearData[0] ? yearData[0].datetime + "-01" : "")
            return yearData
          default:
            return []
        }
      } catch(e) {
        console.log(e)
        this.isDeviceLoading = false
        this.isContentLoading = false
      }
    },
    async getData_comparison() {
      const deviceCodes = []
      let device
      try {
        for (let i = 0; i < this.elctricityMeterList.length; i++) {
          device = this.elctricityMeterList[i]
          if (device.checked) {
            deviceCodes.push(device.code)
          }
        }
        switch (this.activeTimeType_comparison) {
          case "day": 
            if (!this.dayDateStart || !this.dayDateEnd) {
              this.$message.error(this.$t("messages.ctrt"))
              return []
            }
            const { data: dayData1 } = await getDayReport(moment(this.dayDateStart).format("YYYY-MM-DD"), deviceCodes + "")
            const { data: dayData2 } = await  getDayReport(moment(this.dayDateEnd).format("YYYY-MM-DD"), deviceCodes + "")
            return [dayData1.slice(0, -1), dayData2.slice(0, -1)]
          case "week":
            if (!this.weekDateStart || !this.weekDateEnd) {
              this.$message.error(this.$t("messages.ctrt"))
              return []
            }
            const weekStart1 = moment(this.weekDateStart).format("YYYY-MM-DD")
            const weekEnd1 = moment(this.weekDateStart).add(6, "days").format("YYYY-MM-DD")
            const weekStart2 = moment(this.weekDateEnd).format("YYYY-MM-DD")
            const weekEnd2 = moment(this.weekDateEnd).add(6, "days").format("YYYY-MM-DD")
            const { data: weekData1 } = await getMonthReport(weekStart1, weekEnd1, deviceCodes + "")
            const { data: weekData2 } = await  getMonthReport(weekStart2, weekEnd2, deviceCodes + "")
            return [weekData1.slice(0, -1), weekData2.slice(0, -1)]
          case "month":
            if (!this.monthDateStart || !this.monthDateEnd) {
              this.$message.error(this.$t("messages.ctrt"))
              return []
            }
            const monthStart1 = moment(this.monthDateStart).format("YYYY-MM-DD")
            const monthEnd1 = moment(new Date(this.monthDateStart.getFullYear(), this.monthDateStart.getMonth() + 1, 0)).format("YYYY-MM-DD")
            const monthStart2 = moment(this.monthDateEnd).format("YYYY-MM-DD")
            const monthEnd2 = moment(new Date(this.monthDateEnd.getFullYear(), this.monthDateEnd.getMonth() + 1, 0)).format("YYYY-MM-DD")
            const { data: monthData1 } = await getMonthReport(monthStart1, monthEnd1, deviceCodes + "")
            const { data: monthData2 } = await  getMonthReport(monthStart2, monthEnd2, deviceCodes + "")
            return [monthData1.slice(0, -1), monthData2.slice(0, -1)]
          case "year":
            if (!this.yearDateStart || !this.yearDateEnd) {
              this.$message.error(this.$t("messages.ctrt"))
              return []
            }
            const yearStart1 = moment(this.yearDateStart).format("YYYY-MM-DD")
            let yearEnd1 = new Date(this.yearDateStart.getFullYear() + 1, 0, 0)
            if (yearEnd1 > new Date()) {
              yearEnd1 = new Date()
            }
            yearEnd1 = moment(yearEnd1).format("YYYY-MM-DD")
            const yearStart2 = moment(this.yearDateEnd).format("YYYY-MM-DD")
            let yearEnd2 = new Date(this.yearDateEnd.getFullYear() + 1, 0, 0)
            if (yearEnd2 > new Date()) {
              yearEnd2 = new Date()
            }
            yearEnd2 = moment(yearEnd2).format("YYYY-MM-DD")
            const { data: yearData1 } = await getYearReport(yearStart1, yearEnd1, deviceCodes + "")
            const { data: yearData2 } = await  getYearReport(yearStart2, yearEnd2, deviceCodes + "")
            return [yearData1.slice(0, -1), yearData2.slice(0, -1)]
        }
      } catch(e) {
        console.log(e)
        this.isDeviceLoading = false
        this.isContentLoading = false
        return [[], []]
      }
    },
    validateDateRange(field, range) {
      if (this[field]) {
        if ((parseInt(this[field][1] - this[field][0]) / 1000 / 60 / 60 / 24) > range) {
          this.$message.warning(this.$t('messages.moreThanOneMonth'))
          return false
        }
        return true
      }
      return true
    },
    formatData(data = [], start) {
      let d, db, s, year, month, last
      for (let i = 0; i < data.length - 1; i++) {
        d = data[i]
        if (i === 0) {
          switch (this.activeCategory) {
            case "day":
              d.datetime = start + " ~ " + d.datetime
              break
            case "month":
              d.datetime = d.datetime + " 00:00:00 ~ " +  d.datetime + " 24:00:00"
              break
            case "year":
              s = d.datetime.split("-")
              year = +s[0]
              month = +s[1]
              last = moment(+new Date(year, month, 0)).format("YYYY-MM-DD")
              d.datetime = start + " ~ " + last
              break
          }
          d.fs = d.flowMeterAccumulation - d.gasConsumption
          d.fe = d.flowMeterAccumulation
          d.es = d.electricityMeterAccumulation - d.powerConsumption
          d.ee = d.electricityMeterAccumulation
        } else {
          db = data[i - 1]
          switch (this.activeCategory) {
            case "day":
              d.datetime = db.datetime.split(" ~ ")[1] + " ~ " + data[i].datetime
              break
            case "month":
              d.datetime = d.datetime + " 00:00:00 ~ " +  d.datetime + " 24:00:00"
              break
            case "year":
              s = d.datetime.split("-")
              year = +s[0]
              month = +s[1]
              last = moment(+new Date(year, month, 0)).format("YYYY-MM-DD")
              d.datetime = d.datetime + "-01" + " ~ " + last
              break
          }
          d.fs = db.flowMeterAccumulation
          d.fe = d.flowMeterAccumulation
          d.es = db.electricityMeterAccumulation
          d.ee = d.electricityMeterAccumulation
        }
        d.gasConsumption = d.gasConsumption.toFixed(2)
        d.powerConsumption = d.powerConsumption.toFixed(2)
        d.avgConsumption = d.avgConsumption.toFixed(5)
        d.specificPower = d.specificPower.toFixed(4)
        d.fs = d.fs.toFixed(2)
        d.fe = d.fe.toFixed(2)
        d.es = d.es.toFixed(2)
        d.ee = d.ee.toFixed(2)
      }
      data.splice(-1, 0, {
        datetime: "平均值",
        gasConsumption: (data.length ? data.at(-1).gasConsumption / (data.length - 1) : 0).toFixed(2),
        powerConsumption: (data.length ? data.at(-1).powerConsumption / (data.length - 1) : 0).toFixed(2),
        avgConsumption: (data.length ? data.at(-1).avgConsumption : 0).toFixed(5),
        specificPower: (data.length ? data.at(-1).specificPower : 0).toFixed(4)
      })
    },
    async refreshData() {
      this.isContentLoading = true
      const data = await this.getData()
      this.renderTable(data)
      if (!this.charts) {
        this.initCharts()
      }
      this.renderChart(this.activeChartType, this.activeCategory)
    },
    async refreshData_comparison() {
      this.isContentLoading = true
      try {
        const data = await this.getData_comparison()
        
        this.isContentLoading = false
        if (!this.charts) {
          this.initCharts()
        }
        this.comparisonData = data
        this.renderChart_comparison()
      } catch(e) {
        console.log(e)
        this.isDeviceLoading = false
        this.isContentLoading = false
      }
    },
    renderTable(data) {
      this.datas = data
      this.isContentLoading = false
    },
    initCharts() {
      this.charts = {}
      let d
      for (let i = 0; i < this.dataTypeList.length; i++) {
        d = this.dataTypeList[i]
        this.charts[d.dataIndex] = this.$echarts.init(
          document.getElementById(d.dataIndex),
          null,
          {
            renderer: "canvas",
            useDirtyRect: false,
            width: 1650,
            height: 260
          }
        )
        window.addEventListener("resize", this.charts[d.dataIndex].resize)
      }
    },
    renderChart(chartType, timeType) {
      const colors = ["#B36A5F", "#5FAE96", "orange", "#4F72CB"]
      let data, xAxis, min, max, d, value, dv, time, time_o
      this.dataToAnalyse = {}
      for (let i = 0; i < this.dataTypeList.length; i++) {
        data = []
        xAxis = []
        d = this.dataTypeList[i]
        min = "Infinity"
        max = d.dataIndex === "avgConsumption" ? '0.00000' : '0.00'
        for (let j = 0; j < (this.datas || []).length - 2; j++) {
          dv = this.datas[j]
          value = dv[d.dataIndex]
          if (+value > 0) {
            min = +value < +min ? value : min
            max = +value > +max ? value : max
          }
          if (chartType === "bar") {
            data.push({
              value,
              itemStyle: {
                color: colors[i]
              }
            })
          } else {
            data.push(value)
          }
          switch(timeType) {
            case "day":
              time_o = dv.datetime.split(" ~ ")
              time = time_o[0].slice(11, 16) + " ~ " + time_o[1].slice(11, 16)
              break
            case "month":
              time = dv.datetime.slice(0, 10)
              break
            case "year":
              time = dv.datetime.slice(0, 7)
          }
          xAxis.push(time)
        }
        if (min === "Infinity") {
          min = d.dataIndex === "avgConsumption" ? '0.00000' : '0.00'
        }
        d.min = min
        d.max = max
        this.dataToAnalyse[d.dataIndex] = data
        const option = {
          tooltip: {
            trigger: "axis"
          },
          grid: {
            top: '25%',
            bottom: '28%',
            left: '3%',
            right: '1%'
          },
          xAxis: {
            data: xAxis,
            boundaryGap: true,
            axisLabel: {
              showMaxLabel: true,
              interval: 0,
              rotate: data.length > 12 ? 40 : 0,
              color: "#fff"
            },
            axisTick: {
              show: true,
              inside: true,
              alignWithLabel: true
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            }
          },
          yAxis: {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            },
            axisLabel: {
              color: "#fff"
            }
          },
          series: [
            {
              name: d.description[this.lang],
              type: chartType || "line",
              lineStyle: {
                width: 3,
                color: colors[i]
              },
              itemStyle: {
                color: colors[i],
                normal: {
                  label: {
                    show: true,
                    color: "#fff",
                    rotate: data.length > 12 ? 40 : 0,
                    position: "top"
                  }
                }
              },
              smooth: false,
              symbolSize: 0,
              data
            }
          ]
        }
        if(timeType === "day") {
          option.tooltip.formatter = (params) => {
            return `
              <div>
                <p style="margin: 0 8px 15px">${moment(this.dayDate).format("YYYY-MM-DD") + " " + params[0].name}</p>
              </div>
              <div>
                <div style="margin: 0 8px">
                  ${params[0].marker}
                  <span>${params[0].seriesName}</span>
                  <span style="float: right; color: #666; margin-left: 20px; font-weight: 550">${params[0].value}</span>
                </div>
              </div>
            `
          }
        }
        if (timeType === "month") {
          if (data.length > 12) {
            option.grid.bottom = "20%"
          } else {
            option.grid.bottom = "10%"
          }
        }
        if (timeType === "year") {
          option.grid.bottom = "16%"
          option.grid.left = "4%"
        }
        if (timeType === "day" && data.length < 13) {
          option.grid.bottom = "10%"
        }
        this.charts[d.dataIndex].setOption(option, { replaceMerge: ["xAxis", "yAxis", "series", "tooltip"] })
      }
    },
    changeAmmeterOpenSate() {
      this.isAmmeterOpen = !this.isAmmeterOpen
      this.isAmmeterOpenMessage = this.isAmmeterOpen === true ? this.$t('buttons.fold') : this.$t('buttons.expand')
    },
    toggleCategory(c) {
      this.activeCategory = c.key
      this.remarkList = this[`${c.key}RemarkList`]
      this.refreshData()
    },
    toggleCategory_comparison(c) {
      this.activeTimeType_comparison = c.key
      this.refreshData_comparison()
    },
    toggleChartType(t) {
      this.activeChartType = t
      this.renderChart(this.activeChartType, this.activeCategory)
    },
    setDataTypeListAndColumns(u) {
      this.dataTypeList = [
        {
          dataIndex: "powerConsumption",
          key: "powerConsumption",
          description: {
            zh: "用电量(kW·H)",
            en: "Power(kW·H)"
          },
          title: {
            zh: "用电量",
            en: "Power Consumption"
          }
        }
      ]
    },
    toggleContentType(c) {
      this.activeContentType = c
      if (c === 'comparison') {
        this.refreshData_comparison()
      } else {
        this.refreshData()
      }
    },
    renderChart_comparison() {
      const data = this.comparisonData || [[], []]
      let xAxisData = [], length = Math.max(data[0].length, data[1].length)
      let d, series, dataMap = {}, dd, fixed, percent, rotate, grid, n
      let startDate
      let endDate
      switch (this.activeTimeType_comparison) {
        case "day":
          for (let i = 0; i < 24; i++) {
            xAxisData.push((i < 10 ? '0' + i : i) + ":00 ~ " + (i + 1 < 10 ? '0' + (i + 1) : i + 1) + ":00")
          }
          rotate = xAxisData.length > 12 ? 40 : 0
          startDate = moment(this.dayDateStart).format("YYYY-MM-DD")
          endDate = moment(this.dayDateEnd).format("YYYY-MM-DD")
          grid = {
            top: '12%',
            left: '3%',
            right: '3%',
            bottom: '23%'
          }
          break
        case "week":
          grid = {
            top: '12%',
            left: '3.5%',
            right: '3%'
          }
          xAxisData = [this.$t('warningForm.Monday'), this.$t('warningForm.Tuesday'), this.$t('warningForm.Wednesday'), this.$t('warningForm.Thursday'), this.$t('warningForm.Friday'), this.$t('warningForm.Saturday'), this.$t('warningForm.Sunday')]
          rotate = 0
          const s = moment(this.weekDateStart)
          const e = moment(this.weekDateEnd)
          if (this.lang === "zh") {
            startDate = s.isoWeekYear() + '年第' + s.isoWeek() + '周'
            endDate = e.isoWeekYear() + '年第' + e.isoWeek() + '周'
          } else {
            startDate = "Week " + s.isoWeek() + " of " + s.isoWeekYear()
            endDate = "Week " + e.isoWeek() + " of " + e.isoWeekYear()
          }
          if (this.lang === "zh") {
            grid.bottom = "7%"
          }
          if (this.lang === "en") {
            grid.bottom = "7.5%"
          }
          break
        case "month":
          if (data[0][0] || data[1][0]) {
            xAxisData.push(this.lang === "zh" ? '01日' : "1st")
          }
          if (data[0][1] || data[1][1]) {
            xAxisData.push(this.lang === "zh" ? '02日' : "2nd")
          }
          if (data[0][2] || data[1][2]) {
            xAxisData.push(this.lang === "zh" ? '03日' : "3rd")
          }
          for (let i = 4; i <= length; i++) {
            n = (i < 9 ? "0" + i : i) + (this.lang === "zh" ? "日" : "th")
            xAxisData.push(n)
          }
          startDate = moment(this.monthDateStart).format("YYYY-MM")
          endDate = moment(this.monthDateEnd).format("YYYY-MM")
          grid = {
            top: '12%',
            left: '3.5%',
            right: '3%',
            bottom: '6.5%'
          }
          break
        case "year":
          grid = {
            top: '12%',
            left: '4%',
            right: '3%'
          }
          if (this.lang === "zh") {
            xAxisData = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
            grid.bottom = "6.5%"
          }
          if (this.lang === "en") {
            xAxisData = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            grid.bottom = '7.6%'
          }
          startDate = this.yearDateStart.getFullYear()
          endDate = this.yearDateEnd.getFullYear()
          break
      }
      for (let i = 0; i < length; i++) {
        if (data[0][i]) {
          dd = data[0][i]
          for (let key in dd) {
            if (key !== "datetime") {
              fixed = this.dataTypeList.find(d => d.dataIndex === key)?.fixed || 2
              if (dataMap[key]) {
                dataMap[key][0].push(dd[key].toFixed(fixed))
              } else {
                dataMap[key] = [[dd[key].toFixed(fixed)], [], []]
              }
            }
          }
        }
        if (data[1][i]) {
          dd = data[1][i]
          for (let key in dd) {
            if (key !== "datetime") {
              fixed = this.dataTypeList.find(d => d.dataIndex === key)?.fixed || 2
              if (dataMap[key]) {
                dataMap[key][1].push(dd[key].toFixed(fixed))
              } else {
                dataMap[key] = [[], [dd[key].toFixed(fixed)], []]
              }
            }
          }
        }
        if (data[0][i] && data[1][i]) {
          for (let key in data[0][i]) {
            if (key !== "datetime") {
              percent = ((data[0][i][key] === 0) ? 0 : (data[1][i][key] - data[0][i][key]) / data[0][i][key] * 100).toFixed(2)
              dataMap[key][2].push(percent)
            }
          }
        }
      }
      for (let i = 0; i < this.dataTypeList.length; i++) {
        series = []
        d = this.dataTypeList[i]
        series.push({
          name: startDate + " " + d.description[this.lang],
          type: "bar",
          barGap: 0,
          data: dataMap[d.dataIndex]?.[0] || []
        })
        series.push({
          name: endDate + " " + d.description[this.lang],
          type: "bar",
          barGap: 0,
          data: dataMap[d.dataIndex]?.[1] || []
        })
        series.push({
          name: this.$t('dataReport.increase'),
          type: "line",
          yAxisIndex: 1,
          data: (dataMap[d.dataIndex]?.[2]|| []).map(d => {
            if (d < 0) {
              d = {
                value: d,
                label: {
                  show: true,
                  color: "red",
                  position: "top"
                }
              }
            }
            return d
          }),
          label: {
            show: true,
            color: "#fff",
            formatter: "{c}%"
          }
        })
        const option = {
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              let tooltipHtml = params[0].axisValue + '<br>'
              params.forEach(function (item) {
                if (item.seriesName === "增长率" || item.seriesName === "Increase Rate") {
                  tooltipHtml += item.marker + item.seriesName + ': ' + item.value + '%' + '<br>'
                } else {
                  tooltipHtml += item.marker + item.seriesName + ': ' + item.value + '<br>'
                }
              })
              return tooltipHtml
            }
          },
          grid,
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: xAxisData,
              axisLabel: {
                color: "#fff",
                showMaxLabel: true,
                interval: 0,
                rotate,
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                color: "#fff"
              }
            },
            {
              type: 'value',
              axisLabel: {
                color: "#fff",
                formatter: "{value}%"
              },
              splitLine: {
                show: false
              }
            }
          ],
          series
        }
        this.charts[this.dataTypeList[i].dataIndex].setOption(option, { replaceMerge: ["xAxis", "yAxis", "series", "tooltip"] })
      }
      this.isContentLoading = false
    },
    // showRangeModal(e, item, index) {}
    async handleExport() {
      this.isExporting = true
      const deviceCodes = []
      let device
      try {
        for (let i = 0; i < this.elctricityMeterList.length; i++) {
          device = this.elctricityMeterList[i]
          if (device.checked) {
            deviceCodes.push(device.code)
          }
        }
        switch(this.activeCategory) {
          case "day":
            if (!this.dayDate) {
              this.$message.error(this.$t("device.selectTime"))
              return
            }
            const { data: day } = await exportNewReportByDay(deviceCodes + "", moment(this.dayDate).format("YYYY-MM-DD"))
            this.exportData(day, moment(this.dayDate).format("YYYY-MM-DD") + this.$t('station.dataReport1'))
            break
          case "month":
            if (!this.monthDate) {
              this.isContentLoading = false
              this.$message.error(this.$t("placeholder.timeRange"))
              return
            }
            if (!this.validateDateRange("monthDate", 31)) {
              this.isContentLoading = false
              return
            }
            const monthDateStartFormatter = moment(this.monthDate[0]).format("YYYY-MM-DD")
            const { data: month } = await exportNewReportByMonth(deviceCodes + "", monthDateStartFormatter, moment(this.monthDate[1]).format("YYYY-MM-DD"))
            this.exportData(month, monthDateStartFormatter + " ~ " + moment(this.monthDate[1]).format("YYYY-MM-DD") + this.$t('station.dataReport1'))
            break
          case "year":
            if (!this.yearDate) {
              this.$message.error(this.$t("placeholder.timeRange"))
              return []
            }
            const yearDateStartFormatter = moment(this.yearDate[0]).format("YYYY-MM-DD")
            const yearDateEndFormatter = moment(+new Date(this.yearDate[1].getFullYear(), this.yearDate[1].getMonth() + 1, 0)).format("YYYY-MM-DD")
            const { data: year } = await exportNewReportByYear(deviceCodes + "", yearDateStartFormatter, yearDateEndFormatter)
            this.exportData(year, yearDateStartFormatter + " ~ " + yearDateEndFormatter + this.$t('station.dataReport1'))
            break
          default:
            break
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isExporting = false
      }
    },
    exportData(data, name) {
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.download = name + '.xlsx'
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(link.href)
      document.body.removeChild(link)
      this.$message.success('导出成功', 1)
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

li {
  list-style: none;
}

.ant-btn-primary {
  width: auto;
  padding: 0 10px;
  height: 32px;
  margin-left: 15px;
}

.el-range-editor.el-input__inner {
  height: 32px;
  line-height: 32px;
  border: 1px solid #4e5a69;
}

/deep/ .el-date-editor .el-range-input {
  width: 50%;
  color: #CBCFC7;
  background-color: #2f3d4f;
}

.spin_container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dataReport {
  background-color: #2f3d4f;
  min-height: 836px;
  padding: 20px;

  .models {
    display: flex;
    flex: 1;
    color: #a5abb3;
    font-size: 18px;
    li {
      margin-left: 18px;
      cursor: pointer;
      &.active {
        color: #2199e9;
      }
    }
  }

  header {
    display: flex;
    align-items: center;
    h1 {
      font-size: 24px;
      color: #fff;
    }
  }

  .device_wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .flowmeter,
    .ammeter {
      height: 100%;
    }
    li {
      width: 100%;
      background-color: #212d3f;
      margin: 18px 0;
      padding: 10px;
    }
    h3 {
      float: left;
      color: #f8fced;
      margin-bottom: 10px;
    }
    span {
      color: #2d8cfa;
      float: right;
      cursor: pointer;
      .anticon-double-right,
      .anticon-double-left {
        transform: rotateZ(90deg);
      }
    }
    .border {
      clear: both;
      border-bottom: 1px solid #1976cf;
    }

    .body {
      label {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      li {
        float: left;
        margin: 10px 0 10px 10px;
        padding: 0;
        width: 150px;
        height: 24px;
        font-size: 16px;
        background-color: #4a90e2;
        color: #f8fced;
        text-align: center;
        input[type^="checkbox"] {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .deviceName {
        color: #fff;
        float: left;
        width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 8px;
      }
    }
  }

  .content {
    .header {
      .dateController {
        position: relative;
        /deep/ .el-date-editor--week .el-icon-date,
        /deep/ .el-date-editor--week .el-input__suffix-inner .el-input__icon,
        /deep/ .el-date-editor--year .el-icon-date {
          margin-top: -4px;
        }
        /deep/ .el-input__inner {
          font-size: 13px;
        }
        /deep/ .el-date-editor--week.el-input, .el-date-editor--week.el-input__inner {
          width: 320px;
        }
        &.report /deep/ .el-date-editor--monthrange {
          .el-icon-date,
          .el-range__close-icon {
            margin-top: -8px;
          }
        }
        .category_conatiner {
          display: inline-block;
          border: 1px solid #4e5a69;
          border-right: none;
          margin-right: 18px;
          span {
            display: inline-block;
            width: 100px;
            height: 30px;
            border-right: 1px solid #4e5a69;
            color: #cbcfc7;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
            &.active {
              background-color: #2199e9;
              color: #f8fced;
            }
          }
        }
        .timeRange {
          display: inline-block;
          label {
            color: #fff;
            font-size: 16px;
            margin-right: 8px;
          }
        }
      }
    }

    table {
      width: 100%;
      margin-top: 16px;
      border: 1px solid #4a5665;
      color: #a7adb5;
      th,
      td {
        height: 40px;
        padding-left: 15px;
      }
      th {
        border-right: 1px solid #5b6574;
        background-color: #485464;
      }
      td {
        border-top: 1px solid #445161;
        border-right: 1px solid #445161;
      }
    }

    .charts {
      margin-top: 20px;
      position: relative;

      .type {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        color: #a5abb3;
        font-size: 18px;
        li {
          margin-left: 10px;
          cursor: pointer;
          &.active {
            color: #2199e9;
          }
        }
      }

      .charts_group {
        li {
          width: 100%;
          h3 {
            color: #a5abb3;
            font-size: 20px;
            margin-top: 20px;
            margin-bottom: 5px;
          }
          .chart {
            width: 1650px;
          }
          .range_btn {
            padding: 5px 8px;
            border: 1px solid #ccc;
            border-top: none;
            background-color: #2f3d4f;
            color: #ccc;
            cursor: pointer;
          }
          .minandmax {
            position: absolute;
            right: 50%;
            transform: translateX(50%);
            top: 5%;
            display: flex;
            p {
              color: #fff;
              font-size: 16px;
              &:nth-child(1) {
                margin-right: 20px;
              }
            }
          }
        }
      }
    }
  }
}
.remarkUl li {
  margin-bottom: 15px;
  font-size: 15px;
  i {
    font-style: normal;
    font-weight: 600;
  }
}
</style>